export default {
  LoadSalesForceChat: function (sessionData, skillGroup) {
    var url = window.location.href;
    var env;

    if (url.includes('localhost') || url.includes('dev')) {
      env = 'dev';
    } else if (url.includes('test')) {
      env = 'test';
    } else if (url.includes('preview')) {
      env = 'stage';
    } else {
      env = 'prod';
    }
    const envSubdomain = getEnvSubdomain(env);
    const chatOrgID = getChatOrgID(env);

    if (env !== 'prod') {
      window.salesforceChatDetails = {
        chatSelector: 'salesforce_echat',
        chatOrgID: chatOrgID,
        salesforceEchatScrt2Url: `https://parker--${envSubdomain}.sandbox.my.salesforce-scrt.com`, //qa,deva5,uat
        salesforceEchatDeploymentNameGlobal: 'PH_WebChat',
        salesforceEchatDeploymentUrlGlobal: `https://parker--${envSubdomain}.sandbox.my.site.com/ESWWebChat1734458672629`,
        salesforceEchatScriptGlobal: `https://parker--${envSubdomain}.sandbox.my.site.com/ESWWebChat1734458672629/assets/js/bootstrap.min.js`,
        salesforceEchatDeploymentNameLA: 'PH_Web_Chat_LATAM',
        salesforceEchatDeploymentUrlLA: `https://parker--${envSubdomain}.sandbox.my.site.com/ESWPHWebChatLATAM1737410575474`,
        salesforceEchatScriptLA: `https://parker--${envSubdomain}.sandbox.my.site.com/ESWPHWebChatLATAM1737410575474/assets/js/bootstrap.min.js`,
        divisionID: sessionData.countryId?.toLowerCase() || '687pdc',
        language: sessionData.language?.toLowerCase() || 'en',
        country: sessionData.countryCode?.toLowerCase() || 'us',
        url: window.location.href,
        skillName: skillGroup
      };

      window.initSalesforceScript(window.salesforceChatDetails);
    } else {
      window.salesforceChatDetails = {
        chatSelector: 'salesforce_echat',
        chatOrgID: '00DHs000001RTwd',
        salesforceEchatScrt2Url: `https://parker.my.salesforce-scrt.com`, //prod
        salesforceEchatDeploymentNameGlobal: 'PH_WebChat',
        salesforceEchatDeploymentUrlGlobal: `https://parker.my.site.com/ESWWebChat1734458672629`,
        salesforceEchatScriptGlobal: `https://parker.my.site.com/ESWWebChat1734458672629/assets/js/bootstrap.min.js`,
        salesforceEchatDeploymentNameLA: 'PH_Web_Chat_LATAM',
        salesforceEchatDeploymentUrlLA: `https://parker.my.site.com/ESWPHWebChatLATAM1737410575474`,
        salesforceEchatScriptLA: `https://parker.my.site.com/ESWPHWebChatLATAM1737410575474/assets/js/bootstrap.min.js`,
        divisionID: sessionData.countryId?.toLowerCase() || '687pdc',
        language: sessionData.language?.toLowerCase() || 'en',
        country: sessionData.countryCode?.toLowerCase() || 'us',
        url: window.location.href,
        skillName: skillGroup
      };
      window.initSalesforceScript(window.salesforceChatDetails);
    }
  }
};

function getEnvSubdomain(env) {
  switch (env) {
    case 'dev':
      return 'deva5';
    case 'test':
      return 'qa';
    case 'stage':
      return 'uat';
    case 'prod':
      return 'prod';
    default:
      return 'uat'; // Fallback "uat"
  }
}

function getChatOrgID(env) {
  switch (env) {
    case 'dev':
      return '00DTH000002jj6H';
    case 'test':
      return '00DTI0000022xUH';
    case 'stage':
      return '00DTH000002wnFJ';
    case 'prod':
      return '00DHs000001RTwd';
    default:
      return '00DTH000002wnFJ'; // Fallback "uat"
  }
}
